import ReactMarkdown, { type Components } from "react-markdown";
import remarkGfm from "remark-gfm";

// Claude replies in markdown. Render it as markdown, never as raw HTML:
// react-markdown escapes embedded HTML by default, and no rehype-raw here.
const components: Components = {
  p: ({ children }) => <p className="mb-2 last:mb-0">{children}</p>,
  ul: ({ children }) => (
    <ul className="list-disc pl-5 mb-2 last:mb-0 space-y-0.5">{children}</ul>
  ),
  ol: ({ children }) => (
    <ol className="list-decimal pl-5 mb-2 last:mb-0 space-y-0.5">{children}</ol>
  ),
  li: ({ children }) => <li>{children}</li>,
  h1: ({ children }) => (
    <p className="font-semibold text-base mb-1">{children}</p>
  ),
  h2: ({ children }) => <p className="font-semibold mb-1">{children}</p>,
  h3: ({ children }) => <p className="font-semibold mb-1">{children}</p>,
  h4: ({ children }) => <p className="font-semibold mb-1">{children}</p>,
  strong: ({ children }) => (
    <strong className="font-semibold">{children}</strong>
  ),
  a: ({ href, children }) => (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="text-blue-600 dark:text-blue-400 underline"
    >
      {children}
    </a>
  ),
  blockquote: ({ children }) => (
    <blockquote className="border-l-2 border-gray-300 dark:border-gray-600 pl-2 italic mb-2">
      {children}
    </blockquote>
  ),
  pre: ({ children }) => (
    <pre className="bg-gray-200 dark:bg-gray-900 rounded p-2 mb-2 last:mb-0 overflow-x-auto text-xs">
      {children}
    </pre>
  ),
  code: ({ className, children }) =>
    className ? (
      <code className={`font-mono ${className}`}>{children}</code>
    ) : (
      <code className="font-mono text-xs bg-gray-200 dark:bg-gray-700 rounded px-1">
        {children}
      </code>
    ),
  table: ({ children }) => (
    <div className="overflow-x-auto mb-2 last:mb-0">
      <table className="text-xs border-collapse">{children}</table>
    </div>
  ),
  th: ({ children }) => (
    <th className="border border-gray-300 dark:border-gray-600 px-2 py-1 text-left font-semibold">
      {children}
    </th>
  ),
  td: ({ children }) => (
    <td className="border border-gray-300 dark:border-gray-600 px-2 py-1">
      {children}
    </td>
  ),
  hr: () => <hr className="my-2 border-gray-300 dark:border-gray-600" />,
};

export default function MarkdownMessage({ content }: { content: string }) {
  return (
    <div className="break-words">
      <ReactMarkdown remarkPlugins={[remarkGfm]} components={components}>
        {content}
      </ReactMarkdown>
    </div>
  );
}
